export const BLOCK_MUTATION = {
  SET_LESSON_PLANS_IN_BLOCK: (state, lessonPlans) => {
    state.lessonPlansInBlock = lessonPlans;
  }
};
